export const contact = {
  // Hero Section
  badge: 'EDUSPACE Philippines',
  heroTitle: 'Contact Us',
  heroSubtitle: 'We welcome inquiries about our space education program for elementary grades 4-5',

  // Contact Information
  getInTouch: 'Get in Touch',
  addressLabel: 'Address',
  addressLine1: '11F and 16F Strata 100 Building',
  addressLine2: 'Emerald Ave., Ortigas Center',
  addressLine3: 'Pasig City, Philippines',
  phoneLabel: 'Phone',
  phoneNumber: '+632 5310 5375',
  phoneNote: '(11th Floor office)',
  emailLabel: 'Email',
  emailAddress: 'teachers.ican@gmail.com',
  hoursLabel: 'Business Hours',
  hoursWeekdays: 'Weekdays: 09:00 - 21:00',
  hoursWeekends: 'Weekends: 10:00 - 18:00',
  followUs: 'Follow Us',

  // Contact Form
  formTitle: 'Send Us a Message',
  nameLabel: 'Full Name',
  namePlaceholder: 'Enter your name',
  emailLabel: 'Email Address',
  emailPlaceholder: 'Enter your email',
  subjectLabel: 'Subject',
  subjectPlaceholder: 'Enter inquiry subject',
  messageLabel: 'Message',
  messagePlaceholder: 'Write your questions about EDUSPACE program...',
  characterCount: 'characters',
  submitButton: 'Send Inquiry',

  // Map Section
  mapTitle: 'Visit Our',
  mapTitleHighlight: 'Office',
  mapLocation: 'Located on the 11th and 16th floors',

  // Alert Messages
  successMessage: 'Thank you for your inquiry! We will get back to you soon.',
  successMessageKo: '문의해주셔서 감사합니다! 빠른 시일 내에 답변드리겠습니다.'
};
